import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

@Component({
    selector: 'title-message-dialog',
    templateUrl: './title-message-dialog.component.html',
    styleUrls: ['./title-message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TitleMessageDialog implements OnInit {
  static readonly componentName = 'TitleMessageDialog';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor (
    @Inject(MAT_DIALOG_DATA)
    public sysText: any,
    private dialogRef: MatDialogRef<TitleMessageDialog>,
  ) { }

  ngOnInit() {
    this.sysText = this.sysText.sysText;
  }
}
